import { Promise } from 'core-js'
import Vue from 'vue'

import _ from "lodash";

import Organisation from './services/organisation'

const store = new Vue.observable({
  ready: false,
  organisation: {},
  groups: {},
  stats: {}
})

let eventbus = new Vue();

let AuthSync;
const OrganisationCollection = {
  use: ({ authSync }) => {
    AuthSync = authSync;
    console.log("OrganisationCollection Use:",AuthSync);
  },
  isReady: () => store.ready,
  initialised: async () => {
    while (!store.ready) {
      await new Promise(resolve => setTimeout(resolve, 300))
    }
    return
  },
  reset: () => {
    store.ready = false
    store.organisation = {}
    store.stats = {}
  },
  init: async () => {
    OrganisationCollection.reset()

    await Organisation.clear()
    await new Promise((resolve) => setTimeout(resolve,1000))
    let organisations = await Organisation.list({ ignoreCache: true, params: { simple: true } }).then(({ data }) => data)

    //set organisation details
    let organisationStore = {}
    organisations.forEach(organisation => {
      organisationStore[organisation._id] = organisation
    })

    Vue.set(store, 'organisation', organisationStore);

    console.log("OrganisationCollection", store);

    store.ready = true
  },
  refresh: () => {
    if (!store.ready) return
    console.log("can refresh")
    OrganisationCollection.init()
  },
  authSync: AuthSync || function() {},

  eventbus,
  
  get: (id) => store.organisation[id],
  getDetails: async (id) => {
    let organisation = await Organisation.get(id, {ignoreCache: true}).then(({data}) => data);
    if(organisation?._id) Vue.set(store.organisation, organisation._id, organisation);
    return organisation;
  },
  getAssignments: async (id) => {
    const assignments = await Organisation.getAssignments(id, {ignoreCache: true}).then(({data}) => data);
    Vue.set(store.assignments, id, assignments);
    return assignments;
  },
  getStats: async (id) => {
    const stats = await Organisation.getStats(id, {ignoreCache: true}).then(({data}) => data);
    console.log("stats",stats);
    Vue.set(store.stats, id, stats);
    return stats;
  },
  getAll: () => store.organisation,
  list: (options) => {
    let organisations = []
    for (const [key, value] of Object.entries(store.organisation)) {
      if (!value.data || !value.data.archived) organisations.push(store.organisation[key])
    }

    if(options && options.orderBy) return _.orderBy(organisations, options.orderBy);
    return organisations
  },
  getAvatarURL(id) {
    return Vue.prototype.$hub.avatarURL(id,'organisation');
  },

  removeDetails(organisation) {
    if(!organisation) return;
    Vue.delete(store.organisation, organisation._id || organisation);
  },

  getUser: (id, userId) => {
    let organisation = OrganisationCollection.get(id);
    if(!organisation || !organisation.assignments) return null;
    let user = null;
    organisation.assignments.forEach(({users}) => {
      if(!user) user = users.find(({_id}) => _id === userId);
    });
    return user;
  },
  getUserDetails: async (id, userId) => {
    let organisation = OrganisationCollection.get(id);
    if(!organisation || !organisation.assignments) return null;

    let hasUser = null;
    organisation.assignments.forEach(({users}) => {
      if(!hasUser) hasUser = users.find(({_id}) => _id === userId);
    });

    if(!hasUser) return null;

    let user = await Organisation.getUser(id, userId, {ignoreCache: true}).then(({data}) => data);
    if(user?._id) {
      (store.organisation[id].assignments || []).forEach(({users}, index) => {
        let userIndex = users.findIndex(({_id}) => _id === userId);
        if(userIndex > -1) {
          let usersArray = store.organisation[id].assignments[index].users;
          usersArray[userIndex] = {...user};
          Vue.set(store.organisation[id].assignments[index], 'users', usersArray);
        }
      });
    }

    return user;
  },
  getUserRole: (organisationId, userId) => {
    let organisation = OrganisationCollection.get(organisationId?._id || organisationId);
    if(!organisation || !organisation.assignments) throw new Error("no user role found");
    const assignment = organisation.assignments.find(({users}) => (users.map(({_id}) => _id)).includes(userId?._id || userId));
    if(!assignment) throw new Error("no user role found");
    return assignment.role._id;
  },
  updateUser: (user) => {
    const userId = user?._id;

    Object.keys(store.organisation).forEach(organisationId => {
      (store.organisation[organisationId].assignments || []).forEach(({users}, index) => {
        let userIndex = users.findIndex(({_id}) => _id === userId);
        if(userIndex > -1) {
          let usersArray = store.organisation[organisationId].assignments[index].users;
          usersArray[userIndex] = {...user};
          Vue.set(store.organisation[organisationId].assignments[index], 'users', usersArray);
        }
      });
    });
  },

  create: async (payload) => {
    let organisation = await Organisation.create(payload).then(({data}) => data);
    Vue.set(store.organisation, organisation._id, organisation);
    await AuthSync(true);
    return organisation;
  },

  update: async (organisationId, payload) => {
    let organisation = OrganisationCollection.get(organisationId);
    if(!organisation) throw new Error("organisation not found");
    let organisationRes = await Organisation.update(organisationId, payload).then(({data}) => data);
    Vue.set(store.organisation, organisationRes._id, organisationRes);
    return organisationRes;
  },

  remove: async (organisationId, payload) => {
    console.log("Remove organisation", organisationId, organisationId, payload);
    throw new Error("not implemented");
    // let organisation = OrganisationCollection.get(organisationId);
    // if(!organisation) throw new Error("organisation not found");
    // let organisationRes = await Organisation.delete(organisationId, payload).then(({data}) => data);
    // OrganisationCollection.removeDetails(organisation);
    // await AuthSync(true);
    // return organisationRes;
  },

  leave: async (organisationId) => {
    console.log("Leave organisation", organisationId);
    throw new Error("not implemented");
    // let organisation = OrganisationCollection.get(organisationId);
    // if(!organisation) throw new Error("organisation not found");

    // let organisationLeave = await Organisation.leave(organisationId).then(({data}) => data);
    // if(organisationLeave !== "OK") throw new Error("could not leave organisation");
    // Vue.delete(store.organisation, organisation._id);
    // await AuthSync(true);
  },

  assignUser: async (organisationId, userId, roleId) => {
    let organisation = OrganisationCollection.get(organisationId);
    if(!organisation) throw new Error("organisation not found");
    
    // let user = OrganisationCollection.getUser(organisationId, userId);
    // if(!user) throw new Error("user not in organisation");

    let organisationAssign = await Organisation.assign(organisationId, {
      user: userId,
      role: roleId
    }).then(({data}) => data);
    if(organisationAssign !== "OK") throw new Error("user could not be assigned role");

    // let organisationRes = await OrganisationCollection.getDetails(organisationId);
    // if(!organisationRes) throw new Error("organisation not found");

    // Vue.set(store.organisation, organisationRes._id, organisationRes);
  },
  unassignUser: async (organisationId, userId) => {
    let organisation = OrganisationCollection.get(organisationId);
    if(!organisation) throw new Error("organisation not found");
    
    // let user = OrganisationCollection.getUser(organisationId, userId);
    // if(!user) throw new Error("user not in organisation");

    let organisationUnassign = await Organisation.unassign(organisationId, {
      user: userId
    }).then(({data}) => data);
    if(organisationUnassign !== "OK") throw new Error("user could not be unassigned role");

    // let organisationRes = await OrganisationCollection.getDetails(organisationId);
    // if(!organisationRes) throw new Error("organisation not found");

    // Vue.set(store.organisation, organisationRes._id, organisationRes);
  },
  invite: async (organisationId, emails = []) => {
    let organisation = OrganisationCollection.get(organisationId._id || organisationId);
    if(!organisation) throw new Error("organisation not found");
    
    const inviteRes = await Organisation.invite(organisation._id, { emails }).then(({data}) => data);
    return inviteRes;
  },
}

export default OrganisationCollection